"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiAction = void 0;
const Actions_1 = require("./Actions");
const utils_1 = require("../utils");
class MultiAction {
    actions;
    constructor() {
        this.actions = [];
    }
    addActions(actions) {
        this.actions.push(...actions);
        return this;
    }
    static fromActions(actions) {
        return MultiAction.new().addActions(actions);
    }
    toActions() {
        return Array.from(this.actions);
    }
    countActions() {
        return this.actions.length;
    }
    extend(mAction) {
        return this.addActions(mAction.actions);
    }
    static new() {
        return new MultiAction();
    }
    /**
     * Add a CreateAccount Action following previous actions
     */
    createAccount() {
        return this.addActions([Actions_1.Actions.createAccount()]);
    }
    /**
     * Add a DeleteAccount Action following previous actions
     */
    deleteAccount(beneficiaryId) {
        return this.addActions([Actions_1.Actions.deleteAccount({ beneficiaryId })]);
    }
    /**
     * Add a AddKey Action following previous actions
     */
    addKey(publicKey, accessKey) {
        return this.addActions([
            Actions_1.Actions.addKey({
                publicKey,
                accessKey,
            }),
        ]);
    }
    /**
     * Add a DeleteKey Action following previous actions
     */
    deleteKey(publicKey) {
        return this.addActions([Actions_1.Actions.deleteKey({ publicKey })]);
    }
    /**
     * Add a DeployContract Action following previous actions
     */
    deployContract(code) {
        return this.addActions([Actions_1.Actions.deployContract({ code })]);
    }
    /**
     * Add a Stake Action following previous actions
     */
    stake(amount, publicKey) {
        return this.addActions([Actions_1.Actions.stake({ amount, publicKey })]);
    }
    /**
     * Add a FunctionCall Action following previous actions
     */
    functionCall(options) {
        const { methodName, args = {}, attachedDeposit = utils_1.Amount.ZERO, gas = utils_1.Gas.DEFAULT, stringifier = utils_1.Stringifier.json(), } = options;
        return this.addActions([
            Actions_1.Actions.functionCall({
                methodName,
                args: stringifier.stringifyOrSkip(args),
                attachedDeposit,
                gas,
            }),
        ]);
    }
    /**
     * Add a Transfer Action following previous actions
     */
    transfer(amount) {
        return this.addActions([Actions_1.Actions.transfer({ amount })]);
    }
    get ft() {
        return (0, utils_1.fungibleTokenFunctionCall)((options) => this.functionCall(options));
    }
    get nft() {
        return (0, utils_1.nonFungibleTokenFunctionCall)((options) => this.functionCall(options));
    }
    get storage() {
        return (0, utils_1.storageManagementFunctionCall)((options) => this.functionCall(options));
    }
}
exports.MultiAction = MultiAction;
//# sourceMappingURL=MultiAction.js.map